import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Menu,
	MenuItem,
	IconButton,
} from '@material-ui/core';
import React, { useState } from 'react';
import styles from './ProjectAccessibility.module.scss';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import { connect } from 'react-redux';
import { setAlert } from '../../../../../redux/alerts/action';
import CustomizationTooltip from '../../customizationTooltip/CustomizationTooltip';

const ProjectAccessibility = ({
	projectsList,
	setProjectsList,
	handleAddProject,
	handleEditAccessibility,
}) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const [dropdownId, setDropdownId] = useState();

	const handleCloseDropdown = () => {
		setDropdownId();
		setAnchorEl(null);
	};

	const handleOpenDropdown = (e) => {
		let id = e.currentTarget.dataset.id;
		setDropdownId(id);
		setAnchorEl(e.currentTarget);
	};

	const handleRemoveProject = async (projectKey) => {
		let filteredProjectsList = projectsList?.filter(
			(project) => project.key !== projectKey
		);
		if (filteredProjectsList) {
			setProjectsList(filteredProjectsList);
		}
	};

	const styleShow = (index) => {
		if (Number(dropdownId) === Number(index)) {
			return { display: 'block' };
		} else {
			return { display: 'none' };
		}
	};

	return (
		<Table className={styles.content}>
			<TableHead>
				<TableRow>
					<TableCell className={styles.rowCell}>
						Project name
					</TableCell>
					<TableCell className={styles.rowCell}>Roles</TableCell>
					<TableCell>
						<div
							className={styles.addProjectBtn}
							onClick={handleAddProject}
						>
							+ Add project
						</div>
					</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{projectsList &&
					projectsList[0]?.key !== '' &&
					projectsList?.map((project, index) => {
						return (
							<TableRow>
								<TableCell>{project.label}</TableCell>
								<TableCell>{project.role}</TableCell>
								<TableCell>
									<CustomizationTooltip title='Other Actions'>
										<IconButton
											aria-controls={`simple-menu${index}`}
											aria-haspopup='true'
											data-id={index}
											onClick={handleOpenDropdown}
										>
											<MoreVertRoundedIcon />
										</IconButton>
									</CustomizationTooltip>
									<Menu
										id={`simple-menu${index}`}
										anchorEl={anchorEl}
										keepMounted
										open={Boolean(anchorEl)}
										onClose={handleCloseDropdown}
										className={styles.dropdown}
										style={{ ...styleShow(index) }}
										MenuListProps={{ disablePadding: true }}
										PaperProps={{
											style: {
												boxShadow:
													'0px 1px 9px rgba(0, 0, 0, 0.1)',
												width: '173px',
											},
										}}
									>
										<MenuItem
											className={styles.dropdownItem}
											onClick={() => {
												handleEditAccessibility(
													project.key
												);
												setAnchorEl(null);
												setDropdownId();
											}}
										>
											Edit Accessibility
										</MenuItem>
										<hr />
										<MenuItem
											className={`${styles.dropdownItem} ${styles.dropdownItemRemove}`}
											onClick={() => {
												handleRemoveProject(
													project?.key
												);
												setAnchorEl(null);
												setDropdownId();
											}}
										>
											Remove
										</MenuItem>
									</Menu>
								</TableCell>
							</TableRow>
						);
					})}
			</TableBody>
		</Table>
	);
};

export default connect(null, { setAlert })(ProjectAccessibility);
